import { Project, NavigateFn } from '../../utils/interfaces/types';
import LogoLoop from '../../components/commons/LogoLoop';
import './ProjectDetail.css';
import { RiArrowLeftLine } from 'react-icons/ri';
import { useIsMobile } from '../../hooks/useIsMobile';

export interface IProjectDetail {
  project: Project | undefined;
  navigate: NavigateFn;
}
const ArrowLeft = RiArrowLeftLine as React.ElementType;

export function ProjectDetail(props: IProjectDetail) {
  const isMobile = useIsMobile();

  if (!props.project) return null;

  return (
    <div className="project-detail">
      {/* ── Hero ── */}
      <div className="project-detail__hero">
        <img src={props.project.heroImage} alt={props.project.title} />
      </div>

      {/* ── Intro ── */}
      <div className="project-detail__intro">
        <div className="project-detail__titles">
          <h1 className="project-detail__name">{props.project.title}</h1>
          <h3 className="project-detail__subtitle">{props.project.subtitle}</h3>
        </div>
        <p className="project-detail__desc">
          {props.project.description.split('\n').map((line, i) => (
            <span key={i}>
              {line}
              <br />
            </span>
          ))}
        </p>
      </div>

      {/* ── Gallery ── */}
      <div className="project-detail__gallery">
        {props.project.gallery?.map((block, i) => (
          <div
            key={i}
            className={`project-detail__gallery-row gallery-row ${i % 2 === 0 ? 'gallery-row--odd' : 'gallery-row--even'}`}
          >
            <div
              key={i}
              className="project-detail__gallery-items"
              style={
                isMobile && block.mobileRowStyle
                  ? block.mobileRowStyle
                  : block.rowStyle || undefined
              }
            >
              {block.images ? (
                block.images.map((src, j) => (
                  <img
                    key={j}
                    src={src.item}
                    alt={`${props.project?.title} — imatge ${i + 1}.${j + 1}`}
                    style={
                      isMobile && src.mobileItemStyle
                        ? src.mobileItemStyle
                        : src.itemStyle || undefined
                    }
                  />
                ))
              ) : // Videos
              block.videos ? (
                block.videos.map((src, j) => (
                  <video
                    key={j}
                    autoPlay
                    loop
                    muted
                    playsInline
                    src={src.item}
                    style={
                      isMobile && src.mobileItemStyle
                        ? src.mobileItemStyle
                        : src.itemStyle || undefined
                    }
                  />
                ))
              ) : block.imgLoop ? (
                <div
                  style={{
                    position: 'relative',
                    overflow: 'hidden',
                  }}
                >
                  <LogoLoop
                    logos={block.imgLoop}
                    speed={35}
                    direction="left"
                    logoHeight={isMobile ? 200 : 360}
                    gap={15}
                    hoverSpeed={0}
                    scaleOnHover
                  />
                </div>
              ) : (
                // Placeholders
                Array.from({
                  length:
                    block.layout === 'double'
                      ? 2
                      : block.layout === 'thirds'
                        ? 2
                        : 1,
                }).map((_, j) => (
                  <div
                    key={j}
                    className="img-placeholder"
                    style={{
                      height: block.layout === 'single' ? '400px' : '260px',
                      background: '#d5d5d5',
                      aspectRatio:
                        block.layout === 'thirds' && j === 0 ? '1/1' : 'auto',
                    }}
                  >
                    <span>{block.caption || ''}</span>
                  </div>
                ))
              )}
            </div>
            {block.caption && (
              <p className="project-detail__gallery-caption">
                {block.caption.split('\n').map((line, i) => (
                  <span key={i}>
                    {line}
                    <br />
                  </span>
                ))}
              </p>
            )}
          </div>
        ))}
      </div>
      <button
        className="project-detail__back"
        onClick={() => props.navigate('projects')}
      >
        <ArrowLeft /> Projects
      </button>
    </div>
  );
}
